import { createSlice } from '@reduxjs/toolkit';
import type { OpenJobsState } from 'src/types/open-jobs';
import reducers from 'src/redux/open-jobs/reducers';
import extraReducers from 'src/redux/open-jobs/extra-reducers';
import { initialState } from 'src/redux/open-jobs/constants';

const openJobs = createSlice({
  name: 'openJobs',
  initialState,
  reducers,
  extraReducers: (builder) => extraReducers(builder),
});

export const {
  updateOpenJob,
  updateHasPendingActionInServiceRequest,
  resetOpenJobs,
  updateOpenJobsOnPusher,
  updateOpenJobs,
  updateEscalationOnPusher,
} = openJobs.actions;

export default openJobs.reducer;
